/** Public services portal (ops-web landing). */
export const SERVICES_PORTAL_URL =
  (process.env.REACT_APP_SERVICES_URL as string | undefined)?.replace(/\/$/, '') ||
  'https://services.tappytray.com';
